/** Same shape the API's `format: uuid` accepts. Opaque: the client never derives meaning from an ID. */
export const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** Matches `E164Schema` in packages/contracts. */
export const E164_PATTERN = /^\+[1-9][0-9]{7,14}$/;
/** Matches the `dtmf` action schema in packages/contracts. */
export const DTMF_PATTERN = /^[0-9*#A-D]{1,16}$/;
/** Matches the API's Idempotency-Key header check. */
export const IDEMPOTENCY_KEY_PATTERN = /^[a-zA-Z0-9_.:-]{8,128}$/;

export const isUuid = (value: unknown): value is string => typeof value === 'string' && UUID_PATTERN.test(value);
export const isE164 = (value: unknown): value is string => typeof value === 'string' && E164_PATTERN.test(value);

export type UuidFactory = () => string;

export function defaultUuidFactory(): UuidFactory {
  const crypto = globalThis.crypto;
  if (!crypto || typeof crypto.randomUUID !== 'function') {
    throw new Error('crypto.randomUUID is required (secure context in a modern browser or Node 22).');
  }
  return () => crypto.randomUUID();
}

export function newIdempotencyKey(prefix: 'call' | 'act', uuid: UuidFactory): string {
  const id = uuid();
  if (!isUuid(id)) throw new Error('UUID factory returned an invalid value.');
  const key = `bcio-${prefix}-${id.toLowerCase()}`;
  if (!IDEMPOTENCY_KEY_PATTERN.test(key)) throw new Error('Idempotency key outside the API format.');
  return key;
}
